export default __webpack_public_path__ + "static/media/all-temples-kasapuram-card-img.6007a271.png";